import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ProgrammeList from './List';
import ProgrammeCreate from './Create';
import ProgrammeDetail from './Detail';
import { injectIntl } from "react-intl";

const defaultFields = {
    Reference: { visible: false, label: '', required: false },
    Type: { visible: false, label: '', required: false },
    PreviousPlanned: { visible: true, label: '', required: false },
    PlannedCompletion: { visible: true, label: '', required: false },
    Reason: { visible: false, label: '', required: false },
    Change: { visible: false, label: '', required: false },
    MainProgress: { visible: false, label: '', required: false },
    KeyActivities: { visible: false, label: '', required: false },
    Summary: { visible: false, label: '', required: false },
    Changes: { visible: false, label: '', required: false },
    Compensation: { visible: false, label: '', required: false },
}
const defaultReplyFields = {
    Status: { visible: false, label: '', required: false },
    RejectReasons: { visible: false, label: '', required: false },
    Comments: { visible: false, label: '', required: false },
}

///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    const workflowItem = workflowsQA[wfid];
    const fields = { ...defaultFields };
    fields.Type.clauses = workflowItem.clauses;
    fields.Reference = { visible: !!resources.ReferenceLabel, label: resources.ReferenceLabel, required: true };
    fields.PreviousPlanned= { visible: true, label: languageFile['CONTRACT.WF.PROGRAMME.FIELD.PREVIOUSLY_PLANNED'], required: true };
    fields.PlannedCompletion= { visible: true, label: languageFile['CONTRACT.WF.PROGRAMME.FIELD.PLANNED_COMPLETION'], required: true };
    fields.Reason= { visible: !!resources.ReasonLabel, label: resources.ReasonLabel, required: true };
    fields.Change= { visible: !!resources.ChangeLabel, label: resources.ChangeLabel, required: true };
    fields.MainProgress= { visible: !!resources.MainProgressLabel, label: resources.MainProgressLabel, required: true };
    fields.KeyActivities= { visible: !!resources.KeyActivitiesLabel, label: resources.KeyActivitiesLabel, required: true };
    fields.Summary= { visible: !!resources.SummaryLabel, label: resources.SummaryLabel, required: true };
    fields.Changes= { visible: !!resources.ChangesLabel, label: resources.ChangesLabel, required: true };
    fields.Compensation= { visible: !!resources.CompensationLabel, label: resources.CompensationLabel, required: true };
    if (placeholdersQA.Fields) {
        placeholdersQA.Fields.values.forEach(fieldItem => {
            const field = fields[fieldItem.field];
            if (field) {
                field.visible = fieldItem.isActive;
                field.label = fieldItem.display;
                field.required = fieldItem.isActive;
            }
        });
    }

    return fields;
}

///ALL REPLY FIELDS ARE DECIDED WITHIN THE getReplyFields FUNCTION
///THE getReplyFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign replyFields to workflowItem
export const getReplyFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid) => {
    const workflowItem = workflowsQA[wfid];
    const replyFields = { ...defaultReplyFields };
    let replyOptions = workflowItem.replyOptions;
    if (!replyOptions && placeholdersQA.ReplyOptions) {
        replyOptions = placeholdersQA.ReplyOptions.values.filter(item => item.isActive === true);
    }
     let rejectOptions = null;
     if(placeholdersQA.ReplyRejectOptions){
        rejectOptions = placeholdersQA.ReplyRejectOptions.values.filter(item => item.isActive === true);
     } 

    replyFields.Status = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.STATUS"], required: true };
    replyFields.Status.replyOptions = replyOptions;

    replyFields.RejectReasons = { visible: true, label: resources.ReplyRejectReasonLabel, required: true };
    replyFields.RejectReasons.rejectOptions = rejectOptions;
    replyFields.Comments = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.COMMENTS"], required: true };
    return replyFields;
}

class ProgrammeRouter extends React.Component {
    constructor(props) {
        super(props);


        this.documentType = 'Document313con';
        this.notifyingParty = props.workflowItem.notifyingParty;
        this.replyingParty = props.workflowItem.replyingParty;


        this.notificationName = props.workflowItem.notificationName;
        this.abbreviation = props.workflowItem.abbreviation;

        try {
            this.mandateAttachment = props.placeholdersQA.MandateAttachment
                .values.find(phItem => phItem.field === 'MandateAttachment').isActive;
        } catch (error) {
            console.log("MandateAttachment placeholder not available!");
            this.mandateAttachment = false;
        }

        try {
            this.mandateAttachment = props.placeholdersQA.MandateAttachment
                .values.find(phItem => phItem.field === 'MandateAttachment').isActive;
        } catch (error) {
            console.log("MandateAttachment placeholder not available!");
            this.mandateAttachment = false;
        }

        try {
            this.warnAttachment = props.placeholdersQA.WarnAttachment
                .values.find(phItem => phItem.field === 'WarnAttachment').isActive;
        } catch (error) {
            console.log("WarnAttachment placeholder not available!");
            this.warnAttachment = false;
        }
    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { workflowItem } = this.props;

        return (
            <Routes caseSensitive>
                <Route
                    path={workflowItem.config.paths.list}
                    exact
                    element={<ProgrammeList
                        {...this.props}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                    />}
                />
                <Route
                    path={workflowItem.config.paths.create}
                    exact
                    element={
                        workflowItem.userFilters.mainNotice.createAllowed ? (
                            <ProgrammeCreate
                                {...this.props}
                                title={this.notificationName}
                            />) : (
                            <Navigate replace to={workflowItem.paths.defaultPath} />
                        )
                    }
                />
                <Route
                    path={'/:notificationid/*'}
                    exact
                    element={<ProgrammeDetail
                        {...this.props}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                        documentType={this.documentType}
                        notifyUserFilter={workflowItem.notifyUserFilter}
                        mandateAttachment={this.mandateAttachment}
                        warnAttachment={this.warnAttachment}
                    />}
                />
            </Routes>
        );
    }
};




export default injectIntl(ProgrammeRouter);